module.exports = __webpack_public_path__ + "static/media/error.024e775f.png";